import { Switch, Route, Redirect } from 'react-router-dom';
import { chPerm } from 'src/components/helpers';
import Layout from 'src/containers/intranet/home/Layout';
import InstitutionalView from 'src/containers/intranet/InstitutionalView';
import { Button } from 'semantic-ui-react';
import TrainingView from 'src/containers/intranet/TrainingView';
import UsersView from 'src/containers/intranet/users/UsersView';

const IntranetHome = (props) => {
  const hasStaffAccess = chPerm(['staff', 'intranetAdmin'], false);

  if (!hasStaffAccess) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          flexDirection: 'column',
          gap: '1rem',
          padding: '2rem',
        }}
      >
        <h2 style={{ color: '#1e293b', margin: 0 }}>Acceso Restringido</h2>
        <p style={{ color: '#64748b', margin: 0 }}>
          No tienes permisos para acceder a esta sección.
        </p>
        <Button
          onClick={() => {
            localStorage.removeItem('userToken');
            props.history.push('/login');
          }}
        >
          Iniciar sesión con otra cuenta
        </Button>
        <Button onClick={() => props.history.push('/')}>Volver a la página de inicio</Button>
      </div>
    );
  }

  return (
    <Layout>
      <Switch>
        <Route exact path="/intranet/institutional" component={InstitutionalView} />
        <Route exact path="/intranet/asignaciones" component={TrainingView} />
        <Route exact path="/intranet/usuarios" component={UsersView} />
        <Redirect to="/intranet/institutional" />
      </Switch>
    </Layout>
  );
};

export default IntranetHome;
